/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BuildingHomeIcon64Regular = forwardRef('BuildingHomeIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M25.282 11.839a9.5 9.5 0 0 1 13.436 0L58.939 32.06a1.5 1.5 0 0 0 2.122-2.122L40.839 9.717c-4.882-4.881-12.796-4.881-17.678 0L2.94 29.94a1.5 1.5 0 1 0 2.122 2.122l20.221-20.222Z" }),
        React.createElement("path", { d: "M14 33.5a1.5 1.5 0 0 0-3 0v14C11 53.299 15.701 58 21.5 58h21C48.299 58 53 53.299 53 47.5v-14a1.5 1.5 0 0 0-3 0v14a7.5 7.5 0 0 1-7.5 7.5h-21a7.5 7.5 0 0 1-7.5-7.5v-14Z" })));
});
